import "./style.css";

const Cart = ({ currentSale, setCurrentSale }) => {
  const deleteProduct = (currentProduct) => {
    const filtered = currentSale.filter((product) => {
      return product !== currentProduct;
    });
    setCurrentSale(filtered);
  };

  return (
    <div className="cartContainer">
      <div className="cartTitle">
        <p>Carrinho de compras</p>
      </div>
      {currentSale.length === 0 ? (
        <div className="emptyCards">
          <p className="empty">Sua sacola está vazia</p>
          <p className="addItems">Adicione Itens</p>
        </div>
      ) : (
        <div className="cartCards">
          {currentSale.map((product) => (
            <div key={product.id} className="cartProduct">
              <div className="cartProductInfo">
                <div className="imgContainer">
                  <img src={product.img} alt={product.name} />
                </div>
                <div>
                  <p className="productName">{product.name}</p>
                  <p className="productCategory">{product.category}</p>
                </div>
              </div>
              <button
                onClick={() => {
                  deleteProduct(product);
                }}
              >
                Remover
              </button>
            </div>
          ))}
          <span className="totalPrice">
            <p>Total:</p>
            <p className="cartPrice">
              R${" "}
              {currentSale.reduce((product, currentValue) => {
                return product + currentValue.price;
              }, 0)}
            </p>
          </span>
          <button className="deleteAll" onClick={() => setCurrentSale([])}>
            Remover Todos
          </button>
        </div>
      )}
    </div>
  );
};

export default Cart;
